import { handleHttp, loadScript } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {};
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  watch: {},
  methods: {
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popshowflag = false;
      this.popLeftIndex = 0;
    }
  }
};